// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"

import SimpleBar from "simplebar"

import './cartzilla/sticky-navbar'
import './cartzilla/sticky-element'
import './cartzilla/carousel'
import './cartzilla/lightbox'
import './cartzilla/countdown'
import './cartzilla/range-slider'
import './cartzilla/password-toggle'
import './cartzilla/input-formatter'
import './cartzilla/form-validation'
import './cartzilla/autofocus'
import './cartzilla/scroll-top-button'
import './cartzilla/dropdown-hover'
import './cartzilla/popover'
import './cartzilla/filter-list'
import './cartzilla/date-picker'
import './cartzilla/master-checkbox'
import './cartzilla/image-zoom'
import './cartzilla/code-highlight'
import './cartzilla/copy-text'
import './cartzilla/chart'

import "./controllers"
import "@hotwired/turbo-rails"

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
}

// Avoid offcanvas elements from being cached, this fixes a bug where the cart cannot be dismissed if the user clicks the back button.
document.addEventListener('turbo:before-cache', () => {
  // Loop through all offcanvas elements to dismiss any that are currently open
  document.querySelectorAll('.offcanvas').forEach(offcanvasEl => {
    if (offcanvasEl.classList.contains('show')) {
      const instance = bootstrap.Offcanvas.getInstance(offcanvasEl) || new bootstrap.Offcanvas(offcanvasEl);
      instance.hide();
      offcanvasEl.classList.remove('hiding');
      offcanvasEl.classList.remove('show');
    }
  });
  // Clean up any lingering backdrop elements
  document.querySelectorAll('.offcanvas-backdrop').forEach(backdrop => backdrop.remove());
});
